import { DatabaseZap } from 'lucide-react';
import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';
import type { ModuleDefinition } from '../../app/modules';
import { useMigrationAvailable } from './api';

/**
 * Перенесення даних (розділ 11 плану): джерела (Asana, Clockify, УП, таблиці «Структура ЮВ», «Статистика ОЕ»,
 * реєстр регламентів) і ключі доступу, файли вивантажень, завдання імпорту з майстром «доступ → параметри →
 * пробний прогін → застосування → звірка», пошук перенесених об’єктів за старими посиланнями, архів журналу ОЕ.
 * Лише для адміністратора чи власника (область admin). Майстер — повна сторінка без вкладок модуля.
 */
const page = (load: () => Promise<{ default: ComponentType }>): Pick<RouteObject, 'lazy'> => ({
  lazy: async () => ({ Component: (await load()).default }),
});

const migrationModule: ModuleDefinition = {
  key: 'migration',
  label: 'Перенесення даних',
  icon: DatabaseZap,
  basePath: '/migration',
  scope: 'admin',
  // Розділ показується, коли модуль є на сервері (інакше — жодних елементів перенесення).
  useAccess: useMigrationAvailable,
  order: 90,
  routes: [
    {
      ...page(() => import('./MigrationLayout')),
      children: [
        { index: true, ...page(() => import('./pages/SourcesPage')) },
        { path: 'links', ...page(() => import('./pages/LinksPage')) },
        { path: 'oe-journal', ...page(() => import('./pages/OeJournalPage')) },
        { path: 'files', ...page(() => import('./pages/FilesPage')) },
      ],
    },
    { path: 'new/:source', ...page(() => import('./pages/WizardPage')) },
    { path: 'jobs/:jobId', ...page(() => import('./pages/WizardPage')) },
  ],
};

export default migrationModule;
